var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('FilterReport',{on:{"search":_vm.handleSearch}})],1)],1),_c('v-row',{staticClass:"report-content"},[_c('v-col',{attrs:{"cols":"12"}},[_c('Statistic',{attrs:{"query":_vm.query}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }